import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MailDestinataireInput } from 'src/app/shared/models/iCourrier/post/mail-destinataire-input';
import { MailDestinatairePInput } from 'src/app/shared/models/iCourrier/post/mail-destinataire-p-input';
import { MailRecipientDetailsDto } from '../interfaces';
import { MailDestinataire, MailRecipientDeleteDTO } from 'src/app/shared/models/mails/mail-destinataire';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RecipientsService {
  private iCourrierURL;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }
  // Retrieve all mail destinataires (Users + Services)
  getMailsDestinataires(id: number): Observable<MailDestinataire[]> {
    return this.http.get<MailDestinataire[]>(`${this.iCourrierURL}/Mails/${id}/Destinataires`);
  }

  public fetchMailRecipientFullInfos(mailId: number): Observable<MailRecipientDetailsDto[]> {
    return this.http.get<MailRecipientDetailsDto[]>(`${this.iCourrierURL}/Mails/${mailId}/Destinataires/Full`);
  }

  // Set a mail destinataire as principal (User or Service)
  setDestinatairePrincipal(id: number, destinataireP: MailDestinatairePInput) {
    return this.http.put<MailDestinatairePInput>(`${this.iCourrierURL}/Mails/${id}/Destinataires/SetPrincipal`, destinataireP);
  }

  // Add a new mail users destinataires
  addMailsDestinataires(id: number, mailDestinataireInput: MailDestinataireInput): Observable<void> {
    return this.http.post<void>(`${this.iCourrierURL}/Mails/${id}/Users`, mailDestinataireInput);
  }

  // Delete mail users destinataires
  deleteMailsDestinataires(id: number, data: MailRecipientDeleteDTO) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: data,
    };
    return this.http.delete<void>(`${this.iCourrierURL}/Mails/${id}/Users`, options);
  }

  addMailsServicesById(id: number, servicesArray: number[]): Observable<void> {
    const data = {
      services: servicesArray,
    };
    return this.http.post<void>(`${this.iCourrierURL}/Mails/${id}/Services`, data);
  }
}
